import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'rebass';
import { FiSidebar } from 'react-icons/fi';
import { ProtectedField, ProtectedFieldComposite, withProtectedCompactRender } from 'components/ProtectedField';
import FatigueBadge from 'components/FatigueBadge';
import ExpandableText from 'components/ExpandableText';
import { COL_FIRST_NAME, COL_LAST_NAME } from 'utils/constants';

/** Shown in place of a value the panelist has never filled in. */
const EMPTY_VALUE = '-';

class ParticipantItem extends React.Component {
    constructor(props) {
        super(props);

        this.renderHorizontal = this.renderHorizontal.bind(this);
        this.renderVertical = this.renderVertical.bind(this);
    }

    renderHorizontal(customDataColumns) {
        return customDataColumns;
    }

    renderVertical() {
        alert('fix stuff in here');
        return (
            <div>
                <div>
                    <Link to={`/participants/${this.props.participant.id}`}>
                        {this.props.participant.first_name} {this.props.participant.last_name}
                    </Link>
                </div>
                <div>{this.props.participant.email}</div>
                <div>{this.props.participant.phone_number}</div>
            </div>
        );
    }

    render() {
        const customDataColumns = [];
        const that = this;

        const chx = (
            <input
                type="checkbox"
                key={`checkbox-${this.props.participant.id}`}
                data-personid={this.props.participant.id}
                checked={this.props.checkbox_checked[this.props.participant.id]}
                onChange={this.props.onChange}
                name="person_id"
                style={{
                    position: 'absolute',
                    // This allows the checkbox to be centered vertically regardless of the height of the row.
                    // It's important to keep top and transform together.
                    top: '50%',
                    transform: 'translateY(-50%)',
                    left: '0',
                    cursor: 'pointer'
                }}
                onClick={e => {
                    e.stopPropagation();
                }}
                disabled={['all', 'custom_count'].includes(this.props.checkAllOrVisibleStatus)}
            />
        );

        if (this.props.availableColumns_showing) {
            customDataColumns.push(
                <td
                    key={`cdc-${that.props.participant.id}-fullname`}
                    style={{ position: 'sticky', left: 0, zIndex: 2, maxWidth: 0, minWidth: '260px' }}
                    className="sticky-row-style td-row-hover-parent ellipsis"
                >
                    {chx}
                    {/* One flex row keeps the fatigue badge and the name on the same
                        line — the name itself is a flex container, which would otherwise
                        push a preceding inline badge onto its own line. The ml-2 lives
                        here (not on the name) to clear the absolute checkbox. */}
                    <span className="flex items-center gap-1 ml-2">
                        <FatigueBadge style={{ flexShrink: 0 }} panelist={this.props.participant} />
                        <ProtectedFieldComposite
                            classNames={{
                                root: 'protected-field-one-link protected-field-one-link-underline'
                            }}
                            person={this.props.participant}
                            hideable
                            fields={[
                                {
                                    dataKey: COL_FIRST_NAME,
                                    hideable: true,
                                    labels: { unmask: 'Unmask first name' },
                                    renderLayout: node => (
                                        <Link
                                            className="muted strong"
                                            to={`/participants/${this.props.participant.id}`}
                                        >
                                            {node}
                                        </Link>
                                    ),
                                    empty: '-'
                                },
                                {
                                    dataKey: COL_LAST_NAME,
                                    hideable: true,
                                    labels: { unmask: 'Unmask last name' },
                                    empty: '-',
                                    renderLayout: node => (
                                        <Link
                                            className="muted strong"
                                            to={`/participants/${this.props.participant.id}`}
                                        >
                                            {node}
                                        </Link>
                                    )
                                }
                            ]}
                            empty={
                                <Link className="muted strong" to={`/participants/${this.props.participant.id}`}>
                                    Name missing
                                </Link>
                            }
                        />
                    </span>
                    <Button
                        type="button"
                        variant="secondary"
                        className="secondary-tiny td-row-hover-child"
                        sx={{
                            position: 'absolute',
                            right: 0,
                            // This allows the button to be centered vertically regardless of the height of the row.
                            top: '50%',
                            transform: 'translateY(-50%)'
                        }}
                        onClick={e => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.props.onClickPreviewPanelist(this.props.participant);
                        }}
                    >
                        <FiSidebar /> View
                    </Button>
                </td>
            );
        }

        this.props.availableColumns_showing.forEach(col_showing => {
            const col = col_showing;
            if (!col || !col_showing.checked) {
                // skip rendering this column
                return;
            }

            const renderLink = node => (
                <Link className="muted" to={`/participants/${this.props.participant.id}`}>
                    {node}
                </Link>
            );

            customDataColumns.push(
                <td key={`cdc-${that.props.participant.id}-${col.id}`} className="ellipsis">
                    <ProtectedField
                        hideable
                        person={this.props.participant}
                        dataKey={col.title}
                        render={(value, personDataKey, person) =>
                            this.props.compactRender(value, personDataKey, person, { useOptIn: true })
                        }
                        // Any text value gets the inline expand, whatever the column's type
                        // says: "Text" runs to 299 characters and a multi-select joins its
                        // labels without a bound, so both overrun the cell the way "Long
                        // text" does (PFOX-1406).
                        //
                        // Expanding in `renderLayout` rather than `render` keeps the toggle
                        // button outside the `<a>`, where it would be invalid HTML and would
                        // navigate away. What arrives here is compactRender's output, so a
                        // node means a badge — short, and not text we can re-flow. The
                        // placeholder isn't a value, so it doesn't get a toggle either.
                        renderLayout={node =>
                            typeof node === 'string' && node !== EMPTY_VALUE ? (
                                <ExpandableText singleLine text={node} renderText={renderLink} />
                            ) : (
                                renderLink(node)
                            )
                        }
                        empty={EMPTY_VALUE}
                    />
                </td>
            );
        });

        if (this.props.horizontal) {
            return this.renderHorizontal(customDataColumns);
        }
        return this.renderVertical(customDataColumns);
    }
}

export default withProtectedCompactRender(ParticipantItem);
